import script from "./FormVagasView.vue?vue&type=script&setup=true&lang=js"
export * from "./FormVagasView.vue?vue&type=script&setup=true&lang=js"

import "./FormVagasView.vue?vue&type=style&index=0&id=4ba07a80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ba07a80"]])

export default __exports__